<style lang="less">
    .disable {
        cursor: not-allowed !important;
        opacity: 0.4;
    }
</style>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" @handleMouseenter="handleMouseenter(...arguments)" :showTippy="false" />
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    declare var eOrderAct: any;

    const KeyMapKey = {
        align: "alignObject",
        distribute: "distributeObject",
        matchSize: "matchSize",
        lockExpand: "lock",
    };

    @Component({
        components: {
            MenuList,
        },
    })
    export default class ArrangeDrops extends Vue {
        activeShapeOrder: string = "";
        activeKey = "";

        showExpand(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", type, node.offsetTop - scrollTop);
            if (["align", "distribute", "matchSize", "lockExpand"].includes(type)) {
                this.$store.commit("setStatus", {
                    type: "showDropExpand",
                    data: true,
                });
            }
        }
        arrangeClick(type: string) {
            console.log(type);
            let view = window["_view"];
            this.$track("menu", "layout", type);
            switch (type) {
                case "bringFront":
                    view.orderShape(eOrderAct.BringFront);
                    break;
                case "sendBack":
                    view.orderShape(eOrderAct.SendBack);
                    break;
                case "bringForward":
                    view.orderShape(eOrderAct.BringForward);
                    break;
                case "sendBackward":
                    view.orderShape(eOrderAct.SendBackward);
                    break;
                case "group":
                    view.group();
                    break;
                case "ungroup":
                    view.unGroup();
                    break;
                case "unLock":
                    view.unLock();
                    break;
                default:
                    break;
            }
            this.$emit("closeDrop");
        }
        get isSelect() {
            return this.$store.state.shape.isActived;
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get multiSelCount() {
            return this.$store.state.shape.multiSelCount;
        }
        get group() {
            return this.$store.state.shape.group;
        }
        get unGroup() {
            return this.$store.state.shape.unGroup;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        get hasLockStatus() {
            let func = function (x, y) {
                return x || y;
            };
            return !!Object.values(this.$store.state.ui.lockStatus).reduce(func);
        }
        get menuList() {
            let list = [
                {
                    key: "bringFront",
                    shortcut: "Ctrl+Shift+]",
                    disabled: !this.isSelect || this.activeShapeOrder == "top",
                    extraClass: this.activeFunc == "alignMoveTop" && "activeFunc",
                },
                {
                    key: "sendBack",
                    shortcut: "Ctrl+Shift+[",
                    disabled: !this.isSelect || this.activeShapeOrder == "bottom",
                    extraClass: this.activeFunc == "alignMoveBottom" && "activeFunc",
                },
                {
                    key: "bringForward",
                    shortcut: "Ctrl+]",
                    disabled: !this.isSelect || this.activeShapeOrder == "top",
                    extraClass: this.activeFunc == "alignMoveUp" && "activeFunc",
                },
                {
                    key: "sendBackward",
                    shortcut: "Ctrl+[",
                    disabled: !this.isSelect || this.activeShapeOrder == "bottom",
                    extraClass: this.activeFunc == "alignMoveDown" && "activeFunc",
                },
                { divide: true },
                {
                    key: "alignObject",
                    expand: true,
                    active: false,
                    disabled: !this.isMultiSel,
                    extraClass: this.activeFunc == "alignAlign" && "activeFunc",
                },
                {
                    key: "distributeObject",
                    expand: true,
                    active: false,
                    disabled: !this.isMultiSel || this.multiSelCount < 3,
                    extraClass: this.activeFunc == "alignDistribute" && "activeFunc",
                },
                {
                    key: "matchSize",
                    expand: true,
                    active: false,
                    disabled: !this.isMultiSel,
                    extraClass: this.activeFunc == "alignSameSize" && "activeFunc",
                },
                { divide: true },
                {
                    key: "lock",
                    expand: true,
                    active: false,
                    disabled: !this.isSelect,
                    extraClass: this.activeFunc == "alignLock" && "activeFunc",
                },
                {
                    key: "unLock",
                    disabled: !this.isSelect,
                    shortcut: "Ctrl+Shift+Y",
                    extraClass: this.activeFunc == "alignUnlockAll" && "activeFunc",
                },
                {
                    key: "group",
                    disabled: !this.group,
                    shortcut: "Ctrl+G",
                    extraClass: this.activeFunc == "alignGroup" && "activeFunc",
                },
                {
                    key: "ungroup",
                    disabled: !this.unGroup,
                    shortcut: "Ctrl+Shift+G",
                    extraClass: this.activeFunc == "alignUngroup" && "activeFunc",
                },
            ];
            list.forEach((v) => {
                if ("active" in v) {
                    v.active = this.activeKey === v.key;
                }
            });
            let resultList = [];
            list.map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "arrange-drops", list: resultList };
        }
        get dropType() {
            return this.$store.state.ui.dropType;
        }
        get showDropdown() {
            return this.$store.state.ui.showDropdown;
        }
        @Watch("showDropdown")
        changeLayerOpertaion(val) {
            if (this.dropType == 4 && val) {
                // 重新获取activeShape的层级关系
                this.activeShapeOrder = window["_view"].getShapeOrder();
            }

            if (!val) {
                this.activeKey = "";
            }
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "bringFront",
                    () => {
                        event.stopPropagation();
                        this.isSelect && this.arrangeClick("bringFront");
                    },
                ],
                [
                    "sendBack",
                    () => {
                        event.stopPropagation();
                        this.isSelect && this.arrangeClick("sendBack");
                    },
                ],
                [
                    "bringForward",
                    () => {
                        event.stopPropagation();
                        this.isSelect && this.arrangeClick("bringForward");
                    },
                ],
                [
                    "sendBackward",
                    () => {
                        event.stopPropagation();
                        this.isSelect && this.arrangeClick("sendBackward");
                    },
                ],
                [
                    "unLock",
                    () => {
                        event.stopPropagation();
                        this.arrangeClick("unLock");
                    },
                ],
                [
                    "group",
                    () => {
                        event.stopPropagation();
                        this.group && this.arrangeClick("group");
                    },
                ],
                [
                    "ungroup",
                    () => {
                        event.stopPropagation();
                        this.unGroup && this.arrangeClick("ungroup");
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.activeKey = KeyMapKey[key];
            this.showExpand(event, key);
        }
        mounted() {}

        created() {}
        deactivated() {
            this.activeKey = "";
        }
    }
</script>
<i18n>
{
  "zh": {
    "bringFront": "移至顶层",
    "sendBack": "移至底层",
    "bringForward": "前移一层",
    "sendBackward": "后移一层",
    "alignObject": "对齐",
    "distributeObject": "分布",
    "matchSize": "等大小",
    "lock": "锁定",
    "unLock": "解锁",
    "group": "组合",
    "ungroup": "取消组合"
  },
  "en": {
    "bringFront": "Bring to Front",
    "sendBack": "Send to Back",
    "bringForward": "Bring Forward",
    "sendBackward": "Send Backward",
    "alignObject": "Align",
    "distributeObject": "Distribute",
    "matchSize": "Same Size",
    "lock": "Lock",
    "unLock": "Unlock",
    "group": "Group",
    "ungroup": "Ungroup"
  },
  "fr": {
    "bringFront": "Déplacer vers haut",
    "sendBack": "Déplacer vers bas",
    "bringForward": "Avancer",
    "sendBackward": "Reculer",
    "alignObject": "Aligner",
    "distributeObject": "distribuer",
    "matchSize": "Adapter la taille",
    "lock": "Verrouiller",
    "unLock": "Débloquer",
    "group": "Groupe",
    "ungroup": "Dissocier"
  },
  "de": {
    "bringFront": "In den Vordergrund",
    "sendBack": "In den Hintergrund",
    "bringForward": "Ebene nach Vorne",
    "sendBackward": "Ebene nach Hinten",
    "alignObject": "Ausrichten",
    "distributeObject": "Verteilen",
    "matchSize": "Gleiche Größe",
    "lock": "Schließen",
    "unLock": "Öffnen",
    "group": "Gruppieren",
    "ungroup": "Gruppierung auflösen"
  },
  "jp": {
    "bringFront": "最前面へ移動",
    "sendBack": "最背面へ移動",
    "bringForward": "前面へ移動",
    "sendBackward": "背面へ移動",
    "alignObject": "揃え方",
    "distributeObject": "配置",
    "matchSize": "サイズに合わせる",
    "lock": "ロック",
    "unLock": "ロック解除",
    "group": "グループ化",
    "ungroup": "グループ化解除"
  },
  "es": {
    "bringFront": "Traer al frente",
    "sendBack": "Enviar a la espalda",
    "bringForward": "Adelante",
    "sendBackward": "Enviar hacia atrás",
    "alignObject": "Alinear",
    "distributeObject": "Distribuir",
    "matchSize": "Mismo tamaño",
    "lock": "Cerrar",
    "unLock": "Desbloquear",
    "group": "Grupo",
    "ungroup": "Desagruparse"
  },
  "pt": {
    "bringFront": "Trazer para a Frente",
    "sendBack": "Enviar para Trás",
    "bringForward": "Avançar",
    "sendBackward": "Retroceder",
    "alignObject": "Alinhar",
    "distributeObject": "Distribuir",
    "matchSize": "Mesmo Tamanho",
    "lock": "Bloquear",
    "unLock": "Desbloquear",
    "group": "Agrupar",
    "ungroup": "Desagrupar"
  },
  "it": {
    "bringFront": "Porta in Primo Piano",
    "sendBack": "Porta in Secondo Piano",
    "bringForward": "Porta Avanti",
    "sendBackward": "Porta Indietro",
    "alignObject": "Allinea",
    "distributeObject": "Distribuisci",
    "matchSize": "Stesse Dimensioni",
    "lock": "Blocca",
    "unLock": "Sblocca",
    "group": "Raggruppa",
    "ungroup": "Separa"
  },
  "tw": {
    "bringFront": "移至頂層",
    "sendBack": "移至底層",
    "bringForward": "前移一層",
    "sendBackward": "后移一層",
    "alignObject": "對齊",
    "distributeObject": "分佈",
    "matchSize": "等大小",
    "lock": "鎖定",
    "unLock": "解鎖",
    "group": "組合",
    "ungroup": "取消組合"
  }
}
</i18n>
